<template>
  <div class="layout">
    <header class="header">
      <img src="../assets/logo.png" width="100px" />

      <div>
        <slot name="quickmsg"></slot>
      </div>
      <nav class="nav">
        <router-link class="nav__link" to="/warehouselive">Stany online</router-link>
        <router-link class="nav__link" to="/warehouse">Magazyn</router-link>
        <router-link class="nav__link" to="/report">Raport</router-link>
        <router-link
          v-if="userstore && userstore.typ=='admin'"
          class="nav__link"
          to="/users"
        >Użytkownicy</router-link>
        <router-link class="nav__link" to="/logout">Wyloguj</router-link>
      </nav>
      <div class="apicaption">API: {{$config.API_URL}}</div>
    </header>

    <slot></slot>
  </div>
</template>


<script>
export default {
  name: "default",
  methods: {
    mthGetUserDataFromStore() {

        this.userstore = JSON.parse(localStorage.getItem("swmLSuser"));
        console.log("user from store: ");
        console.log(this.userstore);

  }
  },
  data() {
    return {
      userstore: null
    };
  },
  created() {
    this.mthGetUserDataFromStore();
  }
};
</script>

<style>
body {
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  margin: 0;
  padding: 0;
  line-height: 1.5;
}

.layout {
  max-width: 99vw;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  height: 80px;
}

.nav__link {
  margin-left: 20px;
}
.apicaption {
  font-size: 0.7rem;
}
</style>
